var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "agent-picker" }, [
    _c("div", { staticClass: "pr-search" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchText,
            expression: "searchText",
          },
        ],
        attrs: { placeholder: _vm.$t("message.searchRepresentative") },
        domProps: { value: _vm.searchText },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchText = $event.target.value
            },
            _vm.searchChange,
          ],
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "material-icons mx-2 pr-icon" }, [
        _vm._v(" search "),
      ]),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pr-items pr-item-wrapper" },
      _vm._l(_vm.getFilteredItems(), function (item) {
        return _c(
          "div",
          {
            staticClass: "pr-item",
            on: {
              click: function (e) {
                return _vm.toggleItem(e, item.value)
              },
            },
          },
          [
            !_vm.single
              ? _c("a-checkbox", {
                  staticClass: "segment-checkbox",
                  attrs: { checked: _vm.isExists(item.value) },
                  on: {
                    click: function (e) {
                      return _vm.toggleItem(e, item.value)
                    },
                  },
                })
              : _c("a-radio", {
                  staticClass: "segment-radio",
                  attrs: { checked: _vm.isExists(item.value) },
                  on: {
                    click: function (e) {
                      return _vm.toggleItem(e, item.value)
                    },
                  },
                }),
            _vm._v(" "),
            _c("div", { staticClass: "user-data-wrapper" }, [
              _c(
                "div",
                { staticClass: "user-data" },
                [
                  _c("Avatar", {
                    staticClass: "mr-2 avatar",
                    attrs: {
                      size: 30,
                      src: item.gravatar,
                      username: item.name,
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "metas" }, [
                    _c("div", { staticClass: "pr-item-name" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.getUserDepartmentNames(item)) +
                          "\n                        "
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              item.status
                ? _c(
                    "div",
                    {
                      staticClass: "pr-item-status",
                      attrs: {
                        "data-online":
                          _vm.$_.get(_vm.user, "_id") === item.value
                            ? true
                            : item.isOnline,
                        "data-status": item.status.toLowerCase(),
                      },
                    },
                    [
                      _c("div", { staticClass: "pr-item-status-circle" }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.status) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }